import React, { useState, useEffect } from "react";
import {
  GraduationCap,
  Award,
  Star,
  Loader2,
  Briefcase,
  FileText,
  Upload,
} from "lucide-react";
import { FooterComponents } from "../FooterComponent";
import SidebarComponent from "../SidbarComponent";
import TopBarComponent from "../TopBarComponent";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "flowbite-react";
import { getDecodedToken, getAuthHeaders } from "../../utils/auth";
import { countries } from "../data/countries";

const StudentScholarshipApply = () => {
  // Use new selectors from the updated Redux slice

  const [selectedEducationProgram, setSelectedEducationProgram] = useState(JSON.parse(sessionStorage.getItem("selectedEducationProgram")));
  //const educationPrograms = useSelector(selectEducationPrograms);

  

  const navigate = useNavigate();
  const { id } = useParams();
  // Get 'type' from query parameters
  const searchParams = new URLSearchParams(window.location.search);
  const type = searchParams?.get("type");
  const [programid] = useState(useParams() || "");
  const [requirements, setRequirements] = useState([]);
  const [activeTab, setActiveTab] = useState("personal"); // 'personal' or 'documents'
  const [currency, setCurrency] = useState("RW");

  //courses by sector
  const [courses, setCourses] = useState([]);
  const [course, setCourse] = useState("");
  const [form, setForm] = useState({
    currentLevel: "",
    applyLevel: "",
    grade: "",
    isWorking: false,
    workplace: "",
    courseSector: "",
    tuitionFee: "",
    startDate: "",
    endDate: "",
    currency: "",
    hasStartedStudies: false,
    coveredPeriod: "",
    remainingPeriod: "",
    monthlyLivingAllowance: "",
    researchAllowance: "",
    airTicketAllowance: "",
    medicalInsurance: "",
    countryOfStudy: "",
    universityAppliedFor: "",
    courseAppliedFor: "",
    previousStudyCompletionYear: "",
    academicPerformancePercentage: "",
  });
  const [documents, setDocuments] = useState({
    passport: null,
    academicTranscript: null,
    recommendationLetter: null,
    languageCertificate: null,
  });
  const [gradeData, setGradeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = getDecodedToken();

  useEffect(() => {
    const fetchGradeData = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await axios.get(
          process.env.REACT_APP_BASE_URL + "academic-merits/all",
          { headers: getAuthHeaders() }
        );
        setGradeData(response.data);
      } catch (error) {
        console.error("Error fetching grade data:", error);
        setError("Failed to load grade data. Please try again later.");
        toast.error("Failed to load grade data. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchGradeData();
  }, []);

  useEffect(() => {
    // If no scholarship is selected, redirect to scholarship list
    if (!selectedEducationProgram) {
      toast.error(
        "No program selected. Please select a program first."
      );
      //navigate("/studentPortal");
    } else {
      // Set requirements from the selected education program
      setRequirements(selectedEducationProgram?.requirements || []);
    }
  }, []);

  const handleChange = (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm({ ...form, [e.target.name]: value });
  };

  const handleDocumentChange = (e, documentType) => {
    const file = e.target.files[0];
    if (file) {

      // Check if file is already uploaded
      const isDuplicate = Object.values(documents).some(
        (doc) => doc && doc.name === file.name
      );

      if (isDuplicate) {
        toast.error(
          "This file has already been uploaded. Please choose a different file.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
        // Reset the input
        e.target.value = "";
        return;
      }

      // Check file size (4MB limit)
      const maxSize = 4 * 1024 * 1024; // 4MB in bytes
      if (file.size > maxSize) {
        toast.error(
          "File size exceeds 4MB limit. Please choose a smaller file.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
        // Reset the input
        e.target.value = "";
        return;
      }

      // Check file type
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "image/jpg",
      ];

      if (!allowedTypes.includes(file.type)) {
        toast.error(
          "Invalid file type. Please upload a PDF or image file (PNG/JPG).",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
        // Reset the input
        e.target.value = "";
        return;
      }
      setDocuments((prev) => ({
        ...prev,
        [documentType]: file,
      }));

     
      toast.success("File uploaded successfully!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
     
    }
  };

  const handleRemoveDocument = (documentType) => {
    setDocuments((prev) => ({
      ...prev,
      [documentType]: null,
    }));
    toast.info("File removed successfully", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const validateDocuments = () => {
    // Get requirements from the selected education program
    if (!requirements || requirements.length === 0) {
      return true; // No requirements to validate
    }

    const missingDocuments = requirements.filter((req) => {
      const documentKey = req.id || `req-${requirements.indexOf(req)}`;
      return !documents[documentKey];
    });

    if (missingDocuments.length > 0) {
      toast.error(
        `Please upload all required documents: ${missingDocuments
          .map((doc) => doc.name)
          .join(", ")}`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    // Validate required fields based on type
      const requiredFields = ['currentLevel', 'applyLevel', 'grade'];
      const missingFields = [];

      // Check basic required fields
      if (!form.currentLevel) missingFields.push('Current Level');
      if (!form.applyLevel) missingFields.push('Level to Apply For');
      if (!form.grade) missingFields.push('Grade/Overall mark');

      // Additional validation for GOVERNMENT type
      if (type === "GOVERNMENT") {
        if (!form.courseSector) missingFields.push('Field of Study');
        if (!course) missingFields.push('Course');
        if (!currency) missingFields.push('Currency');
        if (!form.tuitionFee) missingFields.push('Tuition Fee');
        if (!form.startDate) missingFields.push('Program Start Date');
        if (!form.endDate) missingFields.push('Program End Date');
        if (!form.countryOfStudy) missingFields.push('Country of Study');
        if (!form.universityAppliedFor) missingFields.push('University Applied For');
        if (!form.courseAppliedFor) missingFields.push('Course Applied For');
        if (!form.previousStudyCompletionYear) missingFields.push('Previous Study Completion Year');
        if (!form.academicPerformancePercentage) missingFields.push('Academic Performance Percentage');
      }

      // If there are missing fields, show error and return
      if (missingFields.length > 0) {
        toast.error(
        `Please fill in the following required fields: ${missingFields.join(', ')}`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
        );
        //navigate("/studentPortal");
        return;
      }

    // Validate all required documents are uploaded
    if (!validateDocuments()) {
      return;
    }

    try {
      // Validate file sizes before submitting
      const maxFileSize = 4 * 1024 * 1024; // 4MB in bytes
      const oversizedFiles = [];

      Object.entries(documents).forEach(([key, file]) => {
        if (file && file.size > maxFileSize) {
          oversizedFiles.push(
            `${file.name} (${(file.size / (1024 * 1024)).toFixed(2)}MB)`
          );
        }
      });

      if (oversizedFiles.length > 0) {
        toast.error(
          `The following files exceed the 4MB limit: ${oversizedFiles.join(
            ", "
          )}. Please compress or replace these files.`,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
        return;
      }

      // Create FormData to send files
      const formData = new FormData();

      // Add all documents to FormData
      Object.entries(documents).forEach(([key, file]) => {
        if (file) {
          formData.append("documents", file);
        }
      });

      // Add other form data
      formData.append("currentLevel", form?.currentLevel);
      formData.append("applyLevel", form?.applyLevel);
      formData.append("grade", form?.grade);
      formData.append("userId", token?.userId);
      formData.append("isWorking", form?.isWorking);
      if (form.isWorking) {
        formData.append("workplace", form?.workplace);
      }
      formData.append("programId", programid?.id);

      if (type === "GOVERNMENT") {
        formData.append("courseSector", form?.courseSector);
        formData.append("course", course);
        formData.append("currency", currency);
        formData.append("tuitionFee", form?.tuitionFee);
        formData.append("monthlyLivingAllowance", form?.monthlyLivingAllowance);
        formData.append("researchAllowance", form?.researchAllowance);
        formData.append("airTicketAllowance", form?.airTicketAllowance);
        formData.append("medicalInsurance", form?.medicalInsurance);
        formData.append("startDate", form?.startDate);
        formData.append("endDate", form?.endDate);
        formData.append("coveredPeriod", form?.coveredPeriod);
        formData.append("remainingPeriod", form?.remainingPeriod);
        formData.append("countryOfStudy", form?.countryOfStudy);
        formData.append("universityAppliedFor", form?.universityAppliedFor);
        formData.append("courseAppliedFor", form?.courseAppliedFor);
        formData.append("previousStudyCompletionYear", form?.previousStudyCompletionYear);
        formData.append("academicPerformancePercentage", form?.academicPerformancePercentage);
      }



      const response = await axios.post(
        process.env.REACT_APP_BASE_URL +
          "hec/abroad-scholarship-application/save_application",
        formData,
        {
          // Only attach the JWT — let the browser set the multipart
          // Content-Type so it includes the required boundary.
          headers: getAuthHeaders(),
        }
      );

      if (response.status === 200) {
        toast.success("Application submitted successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        // Redirect to success page or dashboard
        navigate("/studentPortal");
      }
    } catch (error) {
      console.error("Error submitting application:", error);

      // Handle different error scenarios
      if (error.response?.status === 413) {
        toast.error(
          "Your documents are too large in total. Please compress them and try again.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } else if (
        error.response?.status === 401 ||
        error.response?.status === 403
      ) {
        toast.error(
          "Your session has expired or you are not authorized. Please log in again and retry.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.error("Failed to submit application. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  };

  const fetchCourseBySector = async (sectorId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}hec/priority-course/sector`,
        {
          headers: getAuthHeaders(),
          params: {
            courseSector: sectorId,
          },
        }
      );
      setCourses(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching courses by sector:", error);
      toast.error("Failed to fetch courses. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      throw error;
    }
  };

  const renderPersonalInfoTab = () => (
    <div className="space-y-6">
      {/* Basic Education Information - 2 Column Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label
            htmlFor="currentLevel"
            className="block text-sm font-medium mb-1 text-cyan-900"
          >
            Current Level of Education
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <GraduationCap className="w-5 h-5 text-cyan-500" />
            </div>
            <select
              id="currentLevel"
              name="currentLevel"
              value={form.currentLevel}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
            >
              <option value="">Select your Current education level</option>
              <option value="high school">High School</option>
              <option value="Diploma">Diploma</option>
              <option value="Advanced Diploma">Advanced Diploma</option>
              <option value="Masters">Masters</option>
              <option value="Bachelor">Bachelor</option>
            </select>
          </div>
        </div>

        <div>
          <label
            htmlFor="applyLevel"
            className="block text-sm font-medium mb-1 text-cyan-900"
          >
            Level of Education Applying For
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <GraduationCap className="w-5 h-5 text-cyan-500" />
            </div>
            <select
              id="applyLevel"
              name="applyLevel"
              value={form.applyLevel}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
            >
              <option value="">Select level of Education applying for</option>
              <option value="Bachelor">Bachelor</option>
              <option value="Masters">Masters</option>
              <option value="PhD">PhD</option>
            </select>
          </div>
        </div>
      </div>

      {/* Grade Selection - Full Width */}
      <div>
        <label
          htmlFor="grade"
          className="block text-sm font-medium mb-1 text-cyan-900"
        >
          Grade/Overall mark/Class of Qualification
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Star className="w-5 h-5 text-cyan-500" />
          </div>
          {isLoading ? (
            <div className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg flex items-center justify-center">
              <Loader2 className="w-5 h-5 text-cyan-500 animate-spin" />
              <span className="ml-2 text-sm text-gray-500">
                Loading grades...
              </span>
            </div>
          ) : error ? (
            <div className="w-full pl-10 pr-4 py-2 border border-red-200 rounded-lg bg-red-50">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          ) : (
            <select
              id="grade"
              name="grade"
              value={form.grade}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
            >
              <option value="">Select your grade</option>
              {gradeData.map((grade) => (
                <option key={grade.id} value={grade.id}>
                  {grade.letterGrade} - {grade.degreeQualification} (
                  {grade.marks})
                </option>
              ))}
            </select>
          )}
        </div>
        <p className="mt-1 text-sm text-gray-500">
          Select your current grade level based on your academic performance
        </p>
      </div>

      {/* Employment Status */}
      <div>
        <label className="block text-sm font-medium mb-3 text-cyan-900">
          Are you currently employed?
        </label>
        <div className="flex items-center space-x-6">
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              id="isWorking-yes"
              name="isWorking"
              value="true"
              checked={form.isWorking === true}
              onChange={(e) => setForm({ ...form, isWorking: e.target.value === "true" })}
              className="h-4 w-4 text-cyan-600 focus:ring-cyan-500 border-gray-300"
            />
            <label
              htmlFor="isWorking-yes"
              className="text-sm font-medium text-cyan-900"
            >
              Yes
            </label>
          </div>
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              id="isWorking-no"
              name="isWorking"
              value="false"
              checked={form.isWorking === false}
              onChange={(e) => setForm({ ...form, isWorking: e.target.value === "true" })}
              className="h-4 w-4 text-cyan-600 focus:ring-cyan-500 border-gray-300"
            />
            <label
              htmlFor="isWorking-no"
              className="text-sm font-medium text-cyan-900"
            >
              No
            </label>
          </div>
        </div>
      </div>

      {form.isWorking && (
        <div>
          <label
            htmlFor="workplace"
            className="block text-sm font-medium mb-1 text-cyan-900"
          >
            Your Employer Name
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Briefcase className="w-5 h-5 text-cyan-500" />
            </div>
            <input
              type="text"
              id="workplace"
              name="workplace"
              value={form.workplace}
              onChange={handleChange}
              placeholder="Example: RDB, HEC, Irembo, MINEDUC, Etc.."
              className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
            />
          </div>
        </div>
      )}

      {type === "GOVERNMENT" && (
        <div className="space-y-6">
          {/* Field of Study and Course - 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="fieldOfStudy"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Area of Study
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <GraduationCap className="w-5 h-5 text-cyan-500" />
                </div>
                <select
                  id="fieldOfStudy"
                  name="courseSector"
                  value={form.courseSector || ""}
                  onChange={(e) => {
                    fetchCourseBySector(e.target.value);
                    handleChange(e);
                  }}
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                >
                  <option value="">Select your area of study</option>
                  <option value="AVIATION">Aviation</option>
                  {/* <option value="CONSTRUCTION">Construction</option> */}
                  <option value="HEALTH">Health</option>
                  {/* <option value="BUSINESS">Business</option> */}
                  <option value="ICT">ICT</option>
                  {/* <option value="ARTS">Arts</option> */}
                  {/* <option value="SCIENCE">Science</option> */}
                  {/* <option value="LAW">Law</option> */}
                  {/* <option value="EDUCATION">Education</option> */}
                  {/* <option value="AGRICULTURE">Agriculture</option> */}
                  <option value="NUCLEAR_SCIENCE_AND_TECHNOLOGY">
                    Nuclear Science and Technology
                  </option>
                  <option value="INFRASTRUCTURE">Infrastructure</option>
                  <option value="SPORT">Sport</option>
                  {/* <option value="MINING">Mining</option> */}
                  {/* <option value="TOURISM">Tourism</option> */}
                  {/* <option value="ENVIRONMENTAL">Environmental</option> */}
                </select>
              </div>
            </div>

            <div>
              <label
                htmlFor="course"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Specific Academic Program
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <GraduationCap className="w-5 h-5 text-cyan-500" />
                </div>
                <select
                  id="course"
                  name="course"
                  value={course}
                  onChange={(e) => {
                    setCourse(e.target.value);
                  }}
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                >
                  <option value="">Select Academic Program</option>
                  {courses &&
                    courses
                      .filter((course) => course.priorityLevel === "HIGH")
                      .map((course) => (
                        <option key={course.id} value={course.id}>
                          {course.courseName}
                        </option>
                      ))}
                </select>
              </div>
            </div>
          </div>

          {/* Program Dates - 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="startDate"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Program Start Date
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <GraduationCap className="w-5 h-5 text-cyan-500" />
                </div>
                <input
                  type="date"
                  id="startDate"
                  name="startDate"
                  value={form.startDate || ""}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="endDate"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Program End Date
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <GraduationCap className="w-5 h-5 text-cyan-500" />
                </div>
                <input
                  type="date"
                  id="endDate"
                  name="endDate"
                  value={form.endDate || ""}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>
          </div>

          {/* Country of Study and University - 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="countryOfStudy"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Country of Study
              </label>
              <div className="relative">
                <select
                    id="countryOfStudy"
                    name="countryOfStudy"
                    value={form.countryOfStudy || ""}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-200"
                  >
                    <option value="">Select a country...</option>
                    {countries.map((country) => (
                      <option key={country.code} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
              </div>
            </div>
            <div>
              <label
                htmlFor="universityAppliedFor"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                University Applied For
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <GraduationCap className="w-5 h-5 text-cyan-500" />
                </div>
                <input
                  type="text"
                  id="universityAppliedFor"
                  name="universityAppliedFor"
                  value={form.universityAppliedFor}
                  onChange={handleChange}
                  placeholder="Enter university name"
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>
          </div>

          {/* Course Applied For and Previous Study Year - 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="courseAppliedFor"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Course Applied For
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <GraduationCap className="w-5 h-5 text-cyan-500" />
                </div>
                <input
                  type="text"
                  id="courseAppliedFor"
                  name="courseAppliedFor"
                  value={form.courseAppliedFor}
                  onChange={handleChange}
                  placeholder="Enter specific course name"
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="previousStudyCompletionYear"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Previous Study Completion Year
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <GraduationCap className="w-5 h-5 text-cyan-500" />
                </div>
                <input
                  type="text"
                  id="previousStudyCompletionYear"
                  name="previousStudyCompletionYear"
                  value={form.previousStudyCompletionYear}
                  onChange={handleChange}
                  placeholder="e.g., 2024"
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>
          </div>

          {/* Academic Performance Percentage - Full Width */}
          <div>
            <label
              htmlFor="academicPerformancePercentage"
              className="block text-sm font-medium mb-1 text-cyan-900"
            >
              Academic Performance Percentage
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Star className="w-5 h-5 text-cyan-500" />
              </div>
              <input
                type="text"
                id="academicPerformancePercentage"
                name="academicPerformancePercentage"
                value={form.academicPerformancePercentage}
                onChange={handleChange}
                placeholder="e.g., 85% or 3.5 GPA"
                className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
              />
            </div>
            <p className="mt-1 text-sm text-gray-500">
              Enter your academic performance as a percentage or GPA
            </p>
          </div>

          {/* Currency and Tuition Fee - 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="currency"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Currency
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span className="text-cyan-500 font-medium">$</span>
                </div>
                <select
                  id="currency"
                  name="currency"
                  value={currency}
                  onChange={(e) => {
                    setCurrency(e.target.value);
                  }}
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                >
                  <option value="">Select the currency</option>
                  <option value="RWF">RWF - Rwandan Franc</option>
                  <option value="USD">USD - US Dollar</option>
                  <option value="EUR">EUR - Euro</option>
                  <option value="GBP">GBP - British Pound</option>
                </select>
              </div>
            </div>

            <div>
              <label
                htmlFor="tuitionFee"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Tuition Fee
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span className="text-cyan-500 font-medium">$</span>
                </div>
                <input
                  type="number"
                  id="tuitionFee"
                  name="tuitionFee"
                  value={form.tuitionFee }
                  onChange={handleChange}
                  placeholder="Enter tuition fee"
                  min="0"
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>
            
          </div>

          {/* Allowances - 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="monthlyLivingAllowance"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Monthly Living Allowance
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span className="text-cyan-500 font-medium">$</span>
                </div>
                <input
                  type="number"
                  id="monthlyLivingAllowance"
                  name="monthlyLivingAllowance"
                  value={form.monthlyLivingAllowance }
                  onChange={handleChange}
                  placeholder="Enter monthly allowance"
                  min="0"
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="researchAllowance"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Research Allowance
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span className="text-cyan-500 font-medium">$</span>
                </div>
                <input
                  type="number"
                  id="researchAllowance"
                  name="researchAllowance"
                  value={form.researchAllowance }
                  onChange={handleChange}
                  placeholder="Enter research allowance"
                  min="0"
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="airTicketAllowance"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Air Ticket Allowance
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span className="text-cyan-500 font-medium">$</span>
                </div>
                <input
                  type="number"
                  id="airTicketAllowance"
                  name="airTicketAllowance"
                  value={form.airTicketAllowance }
                  onChange={handleChange}
                  placeholder="Enter air ticket allowance"
                  min="0"
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="medicalInsurance"
                className="block text-sm font-medium mb-1 text-cyan-900"
              >
                Medical Insurance
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span className="text-cyan-500 font-medium">$</span>
                </div>
                <input
                  type="number"
                  id="medicalInsurance"
                  name="medicalInsurance"
                  value={form.medicalInsurance }
                  onChange={handleChange}
                  placeholder="Enter medical insurance cost"
                  min="0"
                  className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                />
              </div>
            </div>
          </div>

          {/* Study Period Status */}
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="hasStartedStudies"
              name="hasStartedStudies"
              checked={form.hasStartedStudies}
              onChange={handleChange}
              className="h-4 w-4 text-cyan-600 focus:ring-cyan-500 border-gray-300 rounded"
            />
            <label
              htmlFor="hasStartedStudies"
              className="text-sm font-medium text-cyan-900"
            >
              Have you already started your studies and want support for the remaining period?
            </label>
          </div>

          {form.hasStartedStudies && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* field to specify the covered period in years*/}
              <div>
                <label
                  htmlFor="coveredPeriod"
                  className="block text-sm font-medium mb-1 text-cyan-900"
                >
                  Covered Period (in months)
                </label>
                <div className="relative">
                  {/* <p className="mt-1 text-sm text-gray-500">
                    How many months have you already completed?
                  </p> */}
                  <input
                    type="number"
                    id="coveredPeriod"
                    name="coveredPeriod"
                    value={form.coveredPeriod}
                    onChange={handleChange}
                    placeholder="Enter covered study period"
                    min="0"
                    step="0.5"
                    className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                  />
                </div>
              </div>
              {/* field to specify the remaining  period in years */}
              <div>
                <label
                  htmlFor="remainingPeriod"
                  className="block text-sm font-medium mb-1 text-cyan-900"
                >
                  Remaining Period (in months)
                </label>
                <div className="relative">
                  {/* <p className="mt-1 text-sm text-gray-500">
                  How many months do you need support for?
                  </p> */}
                  <input
                    type="number"
                    id="remainingPeriod"
                    name="remainingPeriod"
                    value={form.remainingPeriod}
                    onChange={handleChange}
                    placeholder="Enter remaining study period"
                    min="0"
                    step="0.5"
                    className="w-full pl-10 pr-4 py-2 border border-cyan-200 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-colors"
                  />
                </div>
                
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );

  const renderDocumentsTab = () => (
    <div className="space-y-6">
      <div className="bg-cyan-50 p-4 rounded-lg mb-6">
        <h3 className="text-sm font-medium text-cyan-900 mb-2">
          Required Documents
        </h3>
        <p className="text-sm text-cyan-700">
          Please upload your documents. Supported formats: PDF and images (PNG/JPG). Maximum file size: 4MB
        </p>
      </div>
      {/* Warning message for international certificates */}
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-yellow-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-base font-medium text-yellow-800">
                Important Notice for International Certificate Holders
              </h3>
              <div className="mt-2 text-sm text-yellow-700">
                <p>
                  If you have an international certificate, please ensure you obtain an equivalence certificate from the relevant authorities while waiting for the bursary response. This will help expedite your application process.
                </p>
              </div>
            </div>
          </div>
        </div>
      <div className="space-y-4">
        {requirements && requirements.length > 0 ? (
          requirements.map((req, index) => (
            <div key={req.id || index}>
              <label className="block text-sm font-medium mb-1 text-cyan-900">
                {req.name}
              </label>
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-cyan-200 border-dashed rounded-lg">
                <div className="space-y-1 text-center">
                  <FileText className="mx-auto h-12 w-12 text-cyan-400" />
                  {!documents[req.id || `req-${index}`] ? (
                    <>
                      <div className="flex text-sm text-gray-600">
                        <label
                          htmlFor={`document-${req.id || index}`}
                          className="relative cursor-pointer bg-white rounded-md font-medium text-cyan-600 hover:text-cyan-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-cyan-500"
                        >
                          <span>Upload a file</span>
                          <input
                            id={`document-${req.id || index}`}
                            name={`document-${req.id || index}`}
                            type="file"
                            className="sr-only"
                            onChange={(e) =>
                              handleDocumentChange(e, req.id || `req-${index}`)
                            }
                            accept=".pdf,.png,.jpg,.jpeg"
                          />
                        </label>
                        <p className="pl-1">or drag and drop</p>
                      </div>
                      <p className="text-xs text-gray-500">
                        PDF or Image up to 4MB
                      </p>
                    </>
                  ) : (
                    <div className="space-y-2">
                      <div className="flex items-center justify-center space-x-2">
                        <FileText className="h-5 w-5 text-cyan-600" />
                        <span className="text-sm text-cyan-900">
                          {documents[req.id || `req-${index}`].name}
                        </span>
                      </div>
                      <button
                        type="button"
                        onClick={() =>
                          handleRemoveDocument(req.id || `req-${index}`)
                        }
                        className="text-sm text-red-600 hover:text-red-500 focus:outline-none focus:underline"
                      >
                        Remove file
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {req.description && (
                <p className="mt-1 text-sm text-gray-500">{req.description}</p>
              )}
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <FileText className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">
              No requirements found
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Please contact the administrator if you believe this is an error.
            </p>
          </div>
        )}
        
      </div>
    </div>
  );

  return (
    <div className="bg-gray-50">
      <TopBarComponent />
      <aside
        id="logo-sidebar"
        className="app-legacy-aside transition-transform -translate-x-full sm:translate-x-0 bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700"
        aria-label="Sidebar"
      >
        <SidebarComponent />
      </aside>
      <div className="p-4 sm:ml-64">
        <div className="p-4 border-2 border-white border-b rounded-lg dark:border-gray-700">
          <div className="min-h-screen bg-gray-50">
            <div className="text-center mt-8">
              <div className="w-16 h-16 bg-gradient-to-r from-cyan-800 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="w-8 h-8 text-white" />
              </div>
              <h1 className="text-xl font-bold mb-2">
                Scholarship Application
              </h1>
              <p className="text-sm text-gray-600 mb-4">
                Complete your scholarship application by providing your current
                and desired education level.
              </p>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
              <div className="bg-white rounded-lg shadow-sm border border-cyan-200 p-6 max-w-2xl mx-auto">
                <div className="border-b border-gray-200 mb-6">
                  <nav className="flex space-x-8">
                    <button
                      onClick={() => setActiveTab("personal")}
                      className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                        activeTab === "personal"
                          ? "border-cyan-800 text-cyan-800"
                          : "border-transparent text-gray-500 hover:text-cyan-800 hover:border-cyan-200"
                      }`}
                    >
                      Personal Information
                    </button>
                    <button
                      onClick={() => setActiveTab("documents")}
                      className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                        activeTab === "documents"
                          ? "border-cyan-800 text-cyan-800"
                          : "border-transparent text-gray-500 hover:text-cyan-800 hover:border-cyan-200"
                      }`}
                    >
                      Required Documents
                    </button>
                  </nav>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                  {activeTab === "personal"
                    ? renderPersonalInfoTab()
                    : renderDocumentsTab()}

                  <div className="flex justify-between pt-4">
                    {activeTab === "documents" && (
                      <button
                        type="button"
                        onClick={() => setActiveTab("personal")}
                        className="px-4 py-2 border border-cyan-800 text-cyan-800 rounded-lg text-sm font-medium hover:bg-cyan-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 transition-colors"
                      >
                        Back
                      </button>
                    )}
                    {activeTab === "personal" ? (
                      <button
                        onClick={() => setActiveTab("documents")}
                        className="ml-auto px-4 py-2 bg-cyan-800 text-white rounded-lg text-sm font-medium hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 transition-colors"
                      >
                        Next
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="ml-auto px-4 py-2 bg-cyan-800 text-white rounded-lg text-sm font-medium hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 transition-colors"
                      >
                        Submit Application
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div>
          <FooterComponents />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default StudentScholarshipApply;
